module.exports = __webpack_public_path__ + "a1fe94c059b952948ea5e7b27f27eb6c.svg";